import { BaseTheme, Shadows } from "./themeRoot/config";

export const baseShadowsByTheme = (baseTheme: BaseTheme = "green"): Shadows => {
	return {
		shadowPrimarySmall:
			baseTheme === "green"
				? "0px 4px 8px rgba(108, 153, 46, 0.24), 0px 2px 4px rgba(108, 153, 46, 0.24), 0px 1px 2px rgba(108, 153, 46, 0.24)"
				: "0px 4px 8px rgba(242, 79, 0, 0.24), 0px 2px 4px rgba(242, 79, 0, 0.24), 0px 1px 2px rgba(242, 79, 0, 0.24)",
		shadowPrimaryMedium:
			baseTheme === "green"
				? "0px 16px 32px rgba(108, 153, 46, 0.12), 0px 8px 16px rgba(108, 153, 46, 0.12), 0px 4px 8px rgba(108, 153, 46, 0.12), 0px 2px 4px rgba(108, 153, 46, 0.12), 0px 1px 2px rgba(108, 153, 46, 0.12)"
				: "0px 16px 32px rgba(242, 79, 0, 0.12), 0px 8px 16px rgba(242, 79, 0, 0.12), 0px 4px 8px rgba(242, 79, 0, 0.12), 0px 2px 4px rgba(242, 79, 0, 0.12), 0px 1px 2px rgba(242, 79, 0, 0.12)",

		shadowPrimaryLarge:
			baseTheme === "green"
				? "0px 32px 64px rgba(108, 153, 46, 0.16), 0px 16px 32px rgba(108, 153, 46, 0.16), 0px 8px 16px rgba(108, 153, 46, 0.12), 0px 4px 8px rgba(108, 153, 46, 0.12), 0px 2px 4px rgba(108, 153, 46, 0.12), 0px 1px 2px rgba(108, 153, 46, 0.12)"
				: "0px 32px 64px rgba(242, 79, 0, 0.16), 0px 16px 32px rgba(242, 79, 0, 0.16), 0px 8px 16px rgba(242, 79, 0, 0.12), 0px 4px 8px rgba(242, 79, 0, 0.12), 0px 2px 4px rgba(242, 79, 0, 0.12), 0px 1px 2px rgba(242, 79, 0, 0.12)",

		...baseShadows,
	};
};
export const baseShadows = {
	shadowSmall: "0px 4px 8px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.12)",
	shadowMedium:
		"0px 16px 32px rgba(0, 0, 0, 0.08), 0px 8px 16px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.08)",
	shadowMediumHover:
		"0px 16px 32px rgba(0, 0, 0, 0.12), 0px 8px 16px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.08)",
	shadowLarge:
		"0px 32px 64px rgba(0, 0, 0, 0.08), 0px 16px 32px rgba(0, 0, 0, 0.08), 0px 8px 16px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.08)",
};
